/**
 * Formulário que acompanha o que outra pessoa salva (as Configurações da mesa, com o `room.updated`):
 * o campo que a pessoa não mexeu recebe o valor novo; o que ela está editando fica como está. Trocar o
 * formulário inteiro pelo valor novo jogava fora a edição em andamento a cada mudança na mesa.
 */
export function mergeIncoming<T extends Record<string, unknown>>(form: T, before: T, next: T): T {
  const same = (a: unknown, b: unknown) => JSON.stringify(a) === JSON.stringify(b);
  const out = { ...next };
  for (const key of Object.keys(next) as (keyof T)[]) {
    if (!same(form[key], before[key])) out[key] = form[key];
  }
  return out;
}
